import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e4291c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stories" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stories__background" }, null, -1))
const _hoisted_3 = { class: "stories__content" }
const _hoisted_4 = { class: "stories__header" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "button-container"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 2,
  id: "iframe"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "stories__btn-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createVNode(_component_Carousel, {
        ref: "carouselElement",
        wrapAround: true,
        "snap-align": "center",
        breakpoints: _ctx.breakpoints,
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
        class: "stories-carousel"
      }, {
        addons: _withCtx(() => [
          _createVNode(_component_Navigation)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pills, (pill, index) => {
            return (_openBlock(), _createBlock(_component_Slide, {
              key: index,
              class: "pills-list"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass([
              'carousel__item pills',
              { inactive: _ctx.currentPillIndex !== index }
            ])
                }, [
                  (_ctx.currentPillIndex === index && _ctx.pills.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
                        class: "carousel__prv"
                      }, " ← "))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "fake-iframe",
                    onClick: ($event: any) => (_ctx.slideTo(index)),
                    style: _normalizeStyle(
                `background-image: url('https://img.youtube.com/vi/${_ctx.getCodeYoutube(
                  pill.url
                )}/hqdefault.jpg')`
              )
                  }, null, 12, _hoisted_5),
                  (pill.idCourse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("button", {
                          class: "button-link",
                          "data-button-course": "",
                          onClick: ($event: any) => (_ctx.goToCourse(pill.idCourse))
                        }, " ver treinamento ", 8, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentPillIndex === index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.currentPillIndex === index && _ctx.pills.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                        class: "carousel__nxt"
                      }, " → "))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["breakpoints"])
    ])
  ]))
}